(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-right-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-right-tween.js');
"use strict";



const positions = svs.components.onboarding.slides.animations.positions;

const createToRightTween = (el, duration) => gsap.to(el, {
  x: positions.outsideRight,
  duration
});
setGlobal('svs.components.onboarding.animations.tweens.createToRightTween', createToRightTween);

 })(window);